import React from 'react';
import SectionHeading from './SectionHeading';
import AerveilPhone from './AerveilPhone';

const Aerveil = () => (
  <section id="aerveil" className="section bg-cream">
    <div className="shell">
      <SectionHeading
        number="01"
        label="What I am building"
        title="Aerveil makes the call, so the grower is not the one watching."
        intro="Frost tonight. Spray windows. Block by block, for every block they farm, every day of the season."
      />

      <div className="mt-16 grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <p className="eyebrow text-ink-soft">My role</p>
          <p className="prose-body mt-5">
            At Aerveil I own the science. Which physical models we trust, what thresholds
            trigger an alert, and where the engine stays silent because the forecast does not
            support a call. I am on the phone with the growers, and I am the last check before
            anything goes out.
          </p>
          <p className="prose-body mt-4">
            A weather forecast is a description of the atmosphere. It is not a decision. Aerveil
            is the decision layer that sits between the two. It takes conditions for the area,
            the biology of what is planted and how far along it is, and the grower’s own
            playbook, and it compresses the time between “the weather is doing this” and “given
            my playbook, the right call is this.” The damage temperatures come from the standard
            reference tables a farm advisor already works from, not numbers we invented.
          </p>
          <p className="prose-body mt-4">
            It does not replace the grower’s judgment, and it makes that compression auditable so
            they can disagree with it. What matters to the people we build for is that it is on
            call at 4 AM, it speaks their language, and it does not pretend to know things it does
            not know.
          </p>
          <a
            href="https://aerveil.ai"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-solid mt-8"
          >
            aerveil.ai
            <svg
              className="h-3 w-3"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              aria-hidden="true"
            >
              <path d="M7 17L17 7M17 7H8M17 7v9" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
        </div>

        <div className="lg:col-span-7">
          <AerveilPhone />
        </div>
      </div>
    </div>
  </section>
);

export default Aerveil;
